import { FC, useState } from "react"

import Modal from "../modal";
import { StatisticsObjectType } from "./types";

const CustomComponentRightButtonTerritories: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  const [showingModal, setModal] = useState(false);
  const [title, setTitle] = useState("");

  const openModal = (title: string) => {
    setTitle(title);
    setModal(true);
    document.body.style.overflow = 'hidden';
  };

  return (
    <>
      <div className="card mb-2 container-fluid p-0 d-flex flex-row flex-fill">
        <div className="card-header col-6 text-center border-bottom-0 d-flex align-items-center justify-content-center">
          <h1 className="mt-2 mb-0">Cases Total</h1>
        </div>
        <div className="card-body col-6 text-center d-flex align-items-center justify-content-center">
          <h1 className="mt-2 mb-0 fw-bold">
            {StatisticsObjectType.total_cases || 0}
          </h1>
        </div>
      </div>

      <div className="card mb-2 container-fluid p-0 d-flex flex-row flex-fill">
        <div className="card-header col-6 text-center border-bottom-0 d-flex align-items-center justify-content-center">
          <h1 className="mt-2 mb-0">New Practices</h1>
        </div>
        <div className="card-body col-6 text-center d-flex align-items-center justify-content-center">
          <h1
              className="mt-2 mb-0 fw-bold btn-link"
              onClick={() => {
                openModal("New Practices");
              }}
          >
            {StatisticsObjectType.new_practices.count || 0}
          </h1>
        </div>
      </div>

      <div className="card mb-2 container-fluid p-0 d-flex flex-row flex-fill">
        <div className="card-header col-6 text-center border-bottom-0 d-flex align-items-center justify-content-center">
        <h1 className="mt-2 mb-0">New Prescribers</h1>
        </div>
        <div className="card-body col-6 text-center d-flex align-items-center justify-content-center">
          <h1
              className="mt-2 mb-0 fw-bold btn-link"
              onClick={() => {
                openModal("New Prescribers");
              }}
          >
            {StatisticsObjectType.new_prescriber.count || 0}
          </h1>
        </div>
      </div>

      <div className="card mb-2 container-fluid p-0 d-flex flex-row flex-fill">
        <div className="card-header col-6 text-center border-bottom-0 d-flex align-items-center justify-content-center">
        <h1 className="mt-2 mb-0">Transfers</h1>
        </div>
        <div className="card-body col-6 text-center d-flex align-items-center justify-content-center">
          <h1 className="mt-2 mb-0 h1 fw-bold">
            {StatisticsObjectType.received_cases || "0.00%"}
          </h1>
        </div>
      </div>

      {showingModal ? (
          <Modal
              title={title}
              data={
                title === "New Practices"
                    ? StatisticsObjectType.new_practices.data
              : StatisticsObjectType.new_prescriber.data
          }
          onClick={() => setModal(false)}
        ></Modal>
      ) : null}
    </>
  );
}
export default CustomComponentRightButtonTerritories;
